export const VALIDATION_MESSAGES = {
    COMPETENCE_FORMAT: 'Competence must be in YYYY-MM format',
    DATE_FORMAT: 'Date must be in YYYY-MM-DD format',
    DATE_INVALID: (fieldName) => `${fieldName} is not a valid date`,
    DATE_IN_PAST: (fieldName) => `${fieldName} cannot be in the past`,
    FIELD_REQUIRED: (fieldName) => `${fieldName} is required`,
    VALUE_NOT_IN_OPTIONS: (fieldName, options) => {
        const optionsString = options.map(opt => `"${opt}"`).join(' or ');
        return `${fieldName} must be either ${optionsString}`;
    },
    NUMBER_NOT_POSITIVE: (fieldName) => `${fieldName} must be greater than 0`,
    PERCENTAGE_OUT_OF_RANGE: (fieldName) => `${fieldName} must be between 0 and 100`,
};
